import React, { useState } from "react";
import { Box, Button, Typography, Link, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTools } from "../hooks/useTools"
import Modal from "./commons/Modal";
import Parser from 'html-react-parser';
import { HelpOutlineOutlined as HelpIcon } from '@mui/icons-material';
import ModalConfirmar from "./commons/ModalConfirmar";

export function HelpTemas({ texto }) {
    const { t } = useTranslation();
    const { removeTags } = useTools()
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {texto && (
                <Stack 
                width={'300px'}
                border={'groove'} 
                borderRadius={'10px'}
                spacing={2}
                padding={2}
                justifyContent={'center'}
                textAlign={"justify"}
                >
                    <Stack justifyContent={'center'} direction={'row'} spacing={1}>
                        <HelpIcon />
                        <Typography variant="h4">
                            {t("cuestion.tituloayuda")}
                        </Typography>
                    </Stack>
                    <Stack sx={{ height: '120px', overflow: 'hidden' }}>
                        <Typography variant="parrafo">
                            {Parser(texto)}
                        </Typography>
                    </Stack>
                    <Box>
                        {texto.length > 120 &&
                            <Link
                                underline="hover"
                                variant="parrafo2"
                                onClick={() => { handleClickOpen() }}
                                sx={{ cursor: 'pointer' }}
                            >
                                {t("Noticias.leermas")}
                            </Link>
                        }
                        {open && (
                            <Modal title={t("cuestion.tituloayuda")} content={texto} open={open} close={handleClose} >
                                <Button variant={'contained'} onClick={handleClose}>{t('general.cerrar')}</Button>
                            </Modal>
                        )}
                    </Box>
                </Stack>
            )}
        </>
    );
}
